module.exports = __webpack_public_path__ + "static/media/uxui_large_banner.d1aee4f1.jpg";